
const COLOURS = {
  yellow: '#FFFCF0',
  pink:   '#FFF0F7',
  blue:   '#F0FAFF',
  green:  '#F0FFF6',
  purple: '#F9F0FF',
}

export default {
  name: 'UIBlobBackground',

  props: {
    blob: {
      type: String,
      default: 'yellow',
      validator: (val) => Object.keys(COLOURS).includes(val),
    },
  },

  data() {
    return {
      borderRadius: '50% / 50%', // SSR-safe default — replaced on mount
    }
  },

  computed: {
    blobStyle() {
      return {
        backgroundColor: COLOURS[this.blob] || COLOURS.yellow,
        borderRadius: this.borderRadius,
      }
    },
  },

  mounted() {
    // Generate client-side only to avoid SSR hydration mismatch
    this.borderRadius = this.generateBorderRadius()
  },

  methods: {
    randomPct() {
      // Between 40–100% — same range as original
      return `${Math.floor(Math.random() * 61) + 40}%`
    },

    generateSection() {
      return Array.from({ length: 4 }, () => this.randomPct()).join(' ')
    },

    generateBorderRadius() {
      return `${this.generateSection()} / ${this.generateSection()}`
    },
  },
}
